import { render } from "./TodoApp.vue?vue&type=template&id=7b95fedb&scoped=true"
import script from "./TodoApp.vue?vue&type=script&lang=js"
export * from "./TodoApp.vue?vue&type=script&lang=js"

import "./TodoApp.vue?vue&type=style&index=0&id=7b95fedb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b95fedb"]])

export default __exports__